
export const ANALYTICS_NAMES = {
  channel: "Login - Registration",
  login: "Login - Login details",
  registration: "Login - Registration",
  collectDobLastname: "Login - Collect date of birth and lastname",
  verification: "Login - Verification",
  verificationError: "Login - Verification error",
  verificationUnsuccessful: "Login - Verification unsuccessful",
  forgottenPassword: "Login - Forgotten password",
  confirmForgottenPassword: "Login - Forgotton password confirmation"
}
// need this to typescript has something to work with.
// it is actually provided in global scope by
declare var adobeAnalytics: any;

export function sendPageVisitAnalytics(pageName: string) {
  adobeAnalytics.channel = ANALYTICS_NAMES.channel;
  adobeAnalytics.pageName = pageName;
  adobeAnalytics.tl();
}
